import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomTooltipDirection } from '../../custom-tooltip/custom-tooltip';

@Component({
  selector: 'ps-ui-aida-enabled-tooltip',
  template: `
    <ng-template [ngIf]="isAidaEnabled">
      <ps-ui-custom-tooltip [direction]="direction">
        <img
          src="../../../../../../assets/image/blue-stars.svg"
          alt="AIDA icon - three blue stars"
          psUiTooltipTarget
          aria-hidden="true"
        />
        <p psUiTooltipContent class="text-white">
          AIDA&#8482; (AI Delivery Assistant) Active.
        </p>
      </ps-ui-custom-tooltip>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AidaEnabledTooltipComponent {
  @Input()
  public direction: CustomTooltipDirection = 'right';

  @Input()
  public isAidaEnabled: boolean = false;
}
